/**
 * @module lib/paysafe/promise
 * Paysafe's JS API is callback based. We would prefer to
 *   deal with promises since it's 2018 (get with the times, Paysafe).
 */

import paysafe from "lib/paysafe";
import PaysafeError from "lib/paysafe/PaysafeError";

/**
 * @param {string} apiKey single-use-token generating key
 * @param {Object} options setup options
 * @returns {Promise} resolve: instance, reject: error
 */
export function setup(apiKey, options) {
  return new Promise((resolve, reject) => {
    paysafe.fields.setup(apiKey, options, (instance, error) => {
      if (error) {
        reject(error);
      } else {
        resolve(instance);
      }
    });
  }).catch(error => {
    throw new PaysafeError("setup", error);
  });
}

/**
 * @param instance Paysafe instance returned from paysafe.fields.setup
 * @param options tokenize options
 * @returns {Promise} resolve: tokenize result, reject: error
 */
export function tokenize(instance, options) {
  return new Promise((resolve, reject) => {
    instance.tokenize(options, (instance, error, result) => {
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    });
  }).catch(error => {
    throw new PaysafeError("tokenize", error);
  });
}



// WEBPACK FOOTER //
// ./src/lib/paysafe/promise.js